import { __values } from "tslib";
import { KeyboardCode } from '@dnd-kit/core';
import { subtract as getCoordinatesDelta, } from '@dnd-kit/utilities';
import { getScrollElementRect, getScrollPosition } from '../scrollUtil';
var HALF = 2;
export var scrollToNewCoordinates = function (scrollableAncestors, newCoordinates, coordinates, direction, scrollBehavior) {
    var e_1, _a;
    var scrollDelta = {
        x: 0,
        y: 0,
    };
    try {
        for (var scrollableAncestors_1 = __values(scrollableAncestors), scrollableAncestors_1_1 = scrollableAncestors_1.next(); !scrollableAncestors_1_1.done; scrollableAncestors_1_1 = scrollableAncestors_1.next()) {
            var scrollContainer = scrollableAncestors_1_1.value;
            var coordinatesDelta = getCoordinatesDelta(newCoordinates, coordinates);
            var _b = getScrollPosition(scrollContainer), isTop = _b.isTop, isRight = _b.isRight, isLeft = _b.isLeft, isBottom = _b.isBottom, maxScroll = _b.maxScroll, minScroll = _b.minScroll;
            var clampedCoordinates = getClampedCoordinates(scrollContainer, direction, newCoordinates);
            var canScrollX = (direction === KeyboardCode.Right && !isRight) ||
                (direction === KeyboardCode.Left && !isLeft);
            var canScrollY = (direction === KeyboardCode.Down && !isBottom) ||
                (direction === KeyboardCode.Up && !isTop);
            if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                var canFullyScrollToNewCoordinates = (direction === KeyboardCode.Right &&
                    scrollContainer.scrollLeft + coordinatesDelta.x <=
                        maxScroll.x) ||
                    (direction === KeyboardCode.Left &&
                        scrollContainer.scrollLeft + coordinatesDelta.x >=
                            minScroll.x);
                if (canFullyScrollToNewCoordinates) {
                    // We don't need to update coordinates, the scroll adjustment alone will trigger
                    // logic to auto-detect the new container we are over
                    scrollContainer.scrollBy({
                        left: coordinatesDelta.x,
                        behavior: scrollBehavior,
                    });
                    return scrollDelta;
                }
                scrollDelta.x =
                    direction === KeyboardCode.Right
                        ? scrollContainer.scrollLeft - maxScroll.x
                        : scrollContainer.scrollLeft - minScroll.x;
                scrollContainer.scrollBy({
                    left: -scrollDelta.x,
                    behavior: scrollBehavior,
                });
                break;
            }
            else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                var canFullyScrollToNewCoordinates = (direction === KeyboardCode.Down &&
                    scrollContainer.scrollTop + coordinatesDelta.y <=
                        maxScroll.y) ||
                    (direction === KeyboardCode.Up &&
                        scrollContainer.scrollTop + coordinatesDelta.y >=
                            minScroll.y);
                if (canFullyScrollToNewCoordinates) {
                    // We don't need to update coordinates, the scroll adjustment alone will trigger
                    // logic to auto-detect the new container we are over
                    scrollContainer.scrollBy({
                        top: coordinatesDelta.y,
                        behavior: scrollBehavior,
                    });
                    scrollDelta.y = scrollDelta.y - coordinatesDelta.y;
                    return scrollDelta;
                }
                scrollDelta.y =
                    direction === KeyboardCode.Down
                        ? scrollContainer.scrollTop - maxScroll.y
                        : scrollContainer.scrollTop - minScroll.y;
                scrollContainer.scrollBy({
                    top: -scrollDelta.y,
                    behavior: scrollBehavior,
                });
                break;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (scrollableAncestors_1_1 && !scrollableAncestors_1_1.done && (_a = scrollableAncestors_1.return)) _a.call(scrollableAncestors_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return scrollDelta;
};
export var getClampedCoordinates = function (scrollContainer, direction, newCoordinates) {
    var scrollElementRect = getScrollElementRect(scrollContainer);
    return {
        x: Math.min(direction === KeyboardCode.Right
            ? scrollElementRect.right - scrollElementRect.width / HALF
            : scrollElementRect.right, Math.max(direction === KeyboardCode.Right
            ? scrollElementRect.left
            : scrollElementRect.left + scrollElementRect.width / HALF, newCoordinates.x)),
        y: Math.min(direction === KeyboardCode.Down
            ? scrollElementRect.bottom - scrollElementRect.height / HALF
            : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down
            ? scrollElementRect.top
            : scrollElementRect.top + scrollElementRect.height / HALF, newCoordinates.y)),
    };
};
//# sourceMappingURL=helpers.js.map